<template>
  <div class="main">
    <RouterView />
    <div
      v-if="isDev"
      class="version"
    >{{ version }}</div>
  </div>
</template>

<script setup lang="ts">
const isDev = import.meta.env.VITE_APP_ENV === 'development'
const version = import.meta.env.VITE_APP_VERSION

onMounted(() => {
  setSize()
})

function setSize() {
  const setVh = () => {
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty('--vh', `${vh}px`)
  }
  const setVW = () => {
    const vw = window.innerWidth * 0.01
    document.documentElement.style.setProperty('--vw', `${vw}px`)
  }
  setVh()
  setVW()
  window.addEventListener('resize', () => {
    setVh()
    setVW()
  })
}
</script>

<style scoped lang="scss">
.version {
  position: absolute;
  top: 0;
  right: 20px;
  font-size: 15px;
  font-weight: 400;
}
</style>